import { Injectable } from '@angular/core';
import { BehaviorSubject, merge, of, shareReplay, switchMap, withLatestFrom } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { BazisFaqService } from '@bazis/shared/services/faq.service';
import { SHARE_REPLAY_SETTINGS } from '@app/configuration.service';
import { buildFilterStr } from '@bazis/utils';

@Injectable({
    providedIn: 'root',
})
export class FaqService extends BazisFaqService {
    sections$ = merge(this.lang$).pipe(
        withLatestFrom(this.sectionsCache.$),
        switchMap(([lang, cacheSections]) => {
            if (cacheSections[lang]?.length > 0) return of(cacheSections[lang]);
            return this.entityService
                .getEntityList$('faq.section', {
                    params: {
                        sort: 'order',
                        lang: this.apiDocLangsMap[lang],
                        filter: buildFilterStr({ app_type: 'web' }),
                    },
                    limit: 1000,
                    saveSeparateItems: true,
                })
                .pipe(
                    map((result) => result.list),
                    tap((result) => {
                        this.sectionsCache.set({
                            ...this.sectionsCache._,
                            [lang]: result,
                        });
                    }),
                );
        }),
    );

    section$ = this.sections$.pipe(
        filter((sections) => sections?.length),
        map((sections) => sections[0]),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );

    sectionId$ = this.section$.pipe(
        filter(Boolean),
        map((section) => section.id),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );

    currentSubsectionId$ = new BehaviorSubject(null);

    subsections$ = this.sectionId$.pipe(
        switchMap((sectionId) => this.getSubSectionBySection$(sectionId)),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );
}
